import { useContext } from "react"
import { LoginForm } from "source/login/LoginForm"
import { Modal } from "source/shared/components/Modal"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { formattedCents } from "../utils/designationTotal"

export function ContinueUnauthed({ totalCents }: { totalCents: number }) {
  const { login } = useContext(ServerRenderedProps)
  return (
    <Modal>
      <Modal.Show>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <LoginForm emailOnly={login.email_only} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal.Show>
      <Modal.Trigger className="btn">
        Continue to give{totalCents > 0 && ` ${formattedCents(totalCents)}`}
      </Modal.Trigger>
    </Modal>
  )
}
